var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.5 38.5",
    id: "youtube",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M38.5,19.25c0,.27,0,.53-.02.8-.2,4.97-2.33,9.49-5.63,12.8-3.32,3.32-7.82,5.43-12.81,5.63-.26.01-.53.02-.79.02C8.66,38.5,0,29.84,0,19.25c0-5.29,2.17-10.11,5.65-13.6C9.14,2.16,13.95,0,19.25,0s10.11,2.16,13.6,5.65c3.48,3.49,5.65,8.31,5.65,13.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M38.48,20.05c-.2,4.97-2.33,9.49-5.63,12.8-3.32,3.32-7.82,5.43-12.81,5.63-3.95-3.95-7.91-7.91-11.86-11.86-1.06-1.02-1.72-2.45-1.72-4.03v-6.68c0-3.1,2.51-5.61,5.61-5.61h14.35c1.58,0,3.01.66,4.03,1.72,2.68,2.67,5.36,5.35,8.03,8.03Z",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.6,19.75l-6.43,3.18c-.25.14-1.11-.05-1.11-.33v-6.53c0-.29.86-.47,1.12-.33l6.16,3.35c.26.15.53.52.27.66ZM26.42,10.3h-14.35c-3.1,0-5.61,2.51-5.61,5.61v6.68c0,3.1,2.51,5.61,5.61,5.61h14.35c3.1,0,5.61-2.51,5.61-5.61v-6.68c0-3.1-2.51-5.61-5.61-5.61Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.94afe1aa634b30d48cc0982b28364b99.svg";
export { ForwardRef as ReactComponent };